<template>
	<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g clip-path="url(#clip0_15_40)">
	<path fill-rule="evenodd" clip-rule="evenodd" d="M10.385 16.362V9.06661C12.9749 10.2853 14.9807 11.4625 17.353 12.7318C15.3964 13.8169 12.9749 15.0344 10.385 16.362ZM24.8183 5.43829C24.3716 4.84971 23.6102 4.39154 22.7995 4.23986C20.4169 3.78739 5.5523 3.7861 3.17091 4.23986C2.52086 4.36172 1.942 4.65628 1.44475 5.11393C-0.650456 7.0586 0.00608129 17.4872 0.511107 19.1765C0.723475 19.9077 0.998012 20.4351 1.34376 20.7812C1.78922 21.2389 2.39912 21.554 3.09968 21.6953C5.06151 22.1011 15.1685 22.328 22.7581 21.7562C23.4573 21.6343 24.0763 21.3091 24.5645 20.832C26.5017 18.8951 26.3697 7.8808 24.8183 5.43829Z" fill="white"/>
	</g>
	<defs>
	<clipPath id="clip0_15_40">
	<rect width="26" height="26" fill="white"/>
	</clipPath>
	</defs>
	</svg>
</template>



	